import Vue from "vue";
import VueRouter from "vue-router";
import Account from "../components/contents/Account.vue"
import Home from "../components/contents/Home.vue";
import BlocksList from "../components/contents/BlocksList.vue";
import TransactionsList from "../components/contents/TransactionsList.vue";
import Circulating from "../components/contents/Circulating.vue";
import Unwrap from "../components/contents/Unwrap.vue";
import BlockDetail from "../components/contents/BlockDetail.vue";
import TransactionDetail from "../components/contents/TransactionDetail.vue";
import NotFound from "../components/contents/NotFound.vue";
import { RecordOptions } from "../js/fields";
import { parseInt } from "../js/polyfill";
import RichAccountsList from "../components/contents/RichAccountsList.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/", component: Home },
  {
    path: "/blocks",
    component: BlocksList,
    props: (route) => ({
      from_time: route.query.from_time,
      to_time: route.query.to_time,
      bookmark: parseInt(route.query.bookmark) || undefined,
      pagesize: parseInt(route.query.pagesize) || RecordOptions[1],
      direction: route.query.direction,
      function_name: route.query.function_name,
    })
  },
  {
    path: "/blocks/:id",
    component: BlockDetail,
    props: (route) => ({
      bookmark: parseInt(route.query.bookmark) || undefined,
      pagesize: parseInt(route.query.pagesize) || RecordOptions[0],
      direction: route.query.direction,
      id: route.params.id,
    })
  },
  {
    path: "/txs",
    component: TransactionsList,
    props: (route) => ({
      from_time: route.query.from_time,
      to_time: route.query.to_time,
      function_name: route.query.function_name,
      bookmark: parseInt(route.query.bookmark) || undefined,
      pagesize: parseInt(route.query.pagesize) || RecordOptions[1],
      direction: route.query.direction,
    })
  },
  {
    path: "/accounts/:id",
    component: Account,
    props: (route) => ({
      bookmark: parseInt(route.query.bookmark) || undefined,
      pagesize: parseInt(route.query.pagesize) || RecordOptions[0],
      direction: route.query.direction,
      id: route.params.id,
    })
  },
  {
    path: "/txs/:id",
    component: TransactionDetail,
    props: true
  },
  {
    path: "/circulating",
    component: Circulating,
    props: true
  },
  {
    path: "/richaccounts",
    component: RichAccountsList,
    props: true
  },
  {
    path: "/unwrap",
    component: Unwrap,
    props: true
  },
  {
    path: "/err/:id",
    component: NotFound,
    props: true
  }
];

export default new VueRouter({
  routes
});



// WEBPACK FOOTER //
// ./src/router/vue-router.js